import React from 'react';

import PasswordResetLayout from './PasswordResetLayout';

function PasswordResetRequestSuccess() {
  return (
    <PasswordResetLayout success>
      <div style={{ marginBottom: '1rem' }}>
        {i18n.gettext(
          "We've emailed you instructions for setting your password, if an account exists with the email you entered. You should receive them shortly."
        )}
      </div>
      <div style={{ marginBottom: '2rem' }}>
        {i18n.gettext(
          "If you don't receive an email, please make sure you've entered the address you registered with, and check your spam folder."
        )}
      </div>
      <a href="/signin">{i18n.gettext('Go back to sign in')}</a>
    </PasswordResetLayout>
  );
}

export default PasswordResetRequestSuccess;
